"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRouterDom = require("react-router-dom");

var _semanticUiReact = require("semantic-ui-react");

var _redux = require("redux");

var _reactRedux = require("react-redux");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Verification = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Verification, _React$Component);

  function Verification() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Verification.prototype;

  _proto.render = function render() {
    var _this$props$products = this.props.products,
        products = _this$props$products === void 0 ? [] : _this$props$products;
    var productLabel = {
      fontSize: '12px'
    };
    var nineDotMenuItem = {
      width: '50px',
      height: '50px'
    };
    var nineDotMenuImage = {
      width: '29px',
      height: '29px'
    };
    return /*#__PURE__*/React.createElement("div", {
      className: "page--multifaceted-bg-grey"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Container, {
      className: "page-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "register-form"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid, {
      stackable: true,
      centered: true
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
      width: 10
    }, /*#__PURE__*/React.createElement("div", {
      className: "callout"
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid, {
      stackable: true,
      centered: true
    }, /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Row, null, products.map(function (product) {
      var className = 'nine-dot__item';

      if (!product.hasAccess) {
        return /*#__PURE__*/React.createElement("span", null);
      }

      return /*#__PURE__*/React.createElement(_semanticUiReact.Grid.Column, {
        key: product.id
      }, /*#__PURE__*/React.createElement("a", {
        className: className,
        href: product.url,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React.createElement("div", {
        className: "nine-dot-menu__icon",
        style: nineDotMenuItem
      }, /*#__PURE__*/React.createElement("img", {
        src: product.iconLogoLocation,
        alt: product.name,
        style: nineDotMenuImage
      })), /*#__PURE__*/React.createElement("span", {
        style: productLabel
      }, product.name)));
    })))))))));
  };

  return Verification;
}(React.Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.auth.user.isFetching,
    error: state.auth.user.error,
    products: state.auth.products
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({}, dispatch);
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Verification));
/*

- get current organisations who have access to this product
- get products this organisdation has access too

*/


exports["default"] = _default;